import { Component, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-interacoes-analise',
  templateUrl: './modal-interacoes-analise.component.html',
  styleUrls: ['./modal-interacoes-analise.component.scss'],
})
export class ModalInteracoesAnaliseComponent implements AfterViewInit {
  displayedColumns = ['dataHoraUsuario', 'statusOrigemDestino', 'comentario', 'parecer', 'anexos'];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      disciplinaNome: string;
      volumeNome: string;
      revisaoDisplay: string;
      interacoes: any[];
      idAfericao: string;
      analiseId: string;
    },
    private dialogRef: MatDialogRef<ModalInteracoesAnaliseComponent>,
    private router: Router
  ) {
    this.dataSource.data = data.interacoes || [];
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  visualizarAnexos(interacao: any): void {
    this.dialogRef.close();
    this.router.navigate(
      [`detail-afericao/${this.data.idAfericao}/${this.data.analiseId}/${interacao.id}/projeto-funcional/view`],
      { state: { interacaoAnalise: interacao } }
    );
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
